import { walletApi } from "@/betby/api/services";
import { sendTokenExpiredMessage } from "@/betby/models/host/unityMessageService";
import LogUtil from "@/betby/utils/LogUtil";

export type BalanceRequestStatus = "ok" | "network" | "kicked" | "error";

const GENERIC_SPORTS_ERROR_MESSAGE =
  "We're sorry, an error occurred. Please try re-entering the sports play later.";

export async function requestBalanceAndUpdateStore(
  updateBalance: (currency: "sc" | "gc", amount: number) => void,
  skipGlobalErrorHandler: boolean = true,
): Promise<BalanceRequestStatus> {
  try {
    const balanceRes = await walletApi.getBalance({
      options: { skipGlobalErrorHandler },
    });
    if (balanceRes.code === 200 && balanceRes.data?.wallet_info_usd) {
      const { wallet_info_usd } = balanceRes.data;
      updateBalance("sc", wallet_info_usd.cash ?? 0);
      updateBalance("gc", wallet_info_usd.coin ?? 0);
      return "ok";
    }

    if (balanceRes.code === -1) {
      LogUtil.error(
        "[BetbyRenderer] 余额接口返回 code -1，视为网络异常",
        balanceRes,
      );
      return "network";
    }

    if ([401, 4011, 4012, 4013, 4014, 4015].includes(balanceRes.code)) {
      LogUtil.warn(
        `[BetbyRenderer] 余额接口捕获互踢错误码 ${balanceRes.code}，直接弹 Token 过期弹窗`,
      );
      sendTokenExpiredMessage();
      return "kicked";
    }

    LogUtil.error(
      "[BetbyRenderer] 余额接口非 200 且非 -1/4011-4015，视为业务致命错误",
      balanceRes,
    );
    sendTokenExpiredMessage(GENERIC_SPORTS_ERROR_MESSAGE);
    return "error";
  } catch (error) {
    LogUtil.error("[BetbyRenderer] 余额请求异常:", error);
    return "network";
  }
}
